import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import * as Icons from "lucide-react";
import SEO from "../components/SEO";
import { SERVICES } from "../data/services";
import { SITE, callLink } from "../lib/constants";
import useReveal from "../hooks/useReveal";

export default function Services() {
  useReveal();
  return (
    <>
      <SEO
        title="Dental Services in Allahabad | Implants, RCT, Braces & More - Lotus Family Dental"
        description="Complete dental care in Allahabad - dental implants, root canal, braces, teeth whitening, pediatric dentistry, gum treatment and more. MDS specialists."
        keywords="dental services allahabad, dentist prayagraj services, dental treatments"
        canonical="https://lotusfamilydental.me/services"
      />

      <section className="relative overflow-hidden pt-12 lg:pt-20 pb-12">
        <div className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full bg-teal-100/30 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="text-xs uppercase tracking-[0.22em] text-teal-600 font-semibold mb-3">
              Treatments
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-900">
              Every smile deserves the <span className="text-teal-700 font-medium">right specialist.</span>
            </h1>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              From routine cleanings to advanced implants and cosmetic veneers — find expert-led, painless
              treatment for every dental concern.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {SERVICES.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Sparkles;
              return (
                <Link
                  key={s.slug}
                  to={`/services/${s.slug}`}
                  className="reveal group relative bg-white border border-slate-100 rounded-3xl overflow-hidden premium-card"
                  data-testid={`service-card-${s.slug}`}
                  style={{ transitionDelay: `${i * 40}ms` }}
                >
                  <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                    <img
                      src={s.coverImage}
                      alt={s.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-teal-50 text-teal-700 flex items-center justify-center">
                        <Icon className="w-5 h-5" strokeWidth={1.5} />
                      </div>
                      <h3 className="font-heading text-xl font-medium text-slate-900">{s.name}</h3>
                    </div>
                    <p className="text-sm text-slate-500 mt-2">{s.tagline}</p>
                    <div className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-teal-700 group-hover:gap-2 transition-all">
                      Learn more <ArrowRight className="w-4 h-4" />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 lg:py-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 lg:p-12 text-center">
            <h2 className="font-heading text-3xl lg:text-4xl font-light tracking-tight text-slate-900">
              Not sure which treatment you need?
            </h2>
            <p className="mt-3 text-slate-600">
              Call us for a free consultation — our specialists will recommend the right plan for you.
            </p>
            <a
              href={callLink}
              className="mt-6 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-teal-600 text-white font-medium hover:bg-teal-700"
            >
              <Phone className="w-4 h-4" /> {SITE.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
